import { useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { User } from "lucide-react";

export default function Settings() {
  const { user } = useAuth();
  const [prefs] = useState(user?.email_prefs || {});
  const PREF_LABELS = { welcome: "Bienvenue", security: "Sécurité", activity: "Activité",
    project: "Rappels de projet", subscription: "Abonnement", science: "Contenus scientifiques", newsletter: "Newsletter" };

  return (
    <div className="max-w-2xl mx-auto px-6 py-8 animate-fade-up">
      <h1 className="font-serif text-3xl font-bold text-navy">Paramètres</h1>
      <div className="mt-6 bg-white rounded-2xl border border-[#E5E7EB] p-6">
        <div className="flex items-center gap-4">
          <div className="h-16 w-16 rounded-full bg-navy text-lisungi-yellow flex items-center justify-center font-serif text-2xl font-bold">{(user?.name || "U")[0].toUpperCase()}</div>
          <div><p className="font-semibold text-navy text-lg">{user?.name}</p><p className="text-sm text-muted2">{user?.email}</p><span className="text-[10px] font-mono uppercase bg-navy/5 text-navy px-2 py-0.5 rounded mt-1 inline-block">{user?.role}</span></div>
        </div>
      </div>
      <div className="mt-5 bg-white rounded-2xl border border-[#E5E7EB] p-6">
        <p className="font-semibold text-navy mb-4">Préférences e-mail</p>
        <div className="space-y-3">
          {Object.entries(PREF_LABELS).map(([k, label]) => (
            <div key={k} className="flex items-center justify-between text-sm">
              <span className="text-ink">{label}</span>
              <span className={`text-xs font-mono px-2 py-0.5 rounded ${prefs[k] !== false ? "bg-green-50 text-green-700" : "bg-gray-100 text-muted2"}`}>{prefs[k] !== false ? "Activé" : "Désactivé"}</span>
            </div>
          ))}
        </div>
        <p className="text-xs text-muted2 mt-4">Les notifications e-mail transactionnelles seront activées avec le fournisseur d'envoi.</p>
      </div>
    </div>
  );
}
